<div class="tech-support-wizard-page">
    <avi-alert-group
        *ngIf="!showProgressNote"
        [alertType]="alertType"
    >
        <span> {{ alertMessage }} </span>
    </avi-alert-group>
    <div 
        *ngIf="showProgressNote"
        class="tech-support-wizard-page__progress-note"
    >
        <img src="src/img/progress-timer.svg"/>
        <p>{{ l10nKeys.progressMessage | vtranslate }}</p> 
    </div>
    <div 
        *ngIf="showProgressNote"
        class="tech-support-wizard-page__progressbar"
    >
        <avi-progress-bar
            [percentage]="progress"
            [hidePercentage]="true"
            [small]="true"
        ></avi-progress-bar>
    </div>
    <avi-data-grid
        [config]="techSupportLevelGridConfig"
        [rows]="techSupportLevel"
    ></avi-data-grid>
    <clr-accordion 
        *ngIf="page === 'preCheck'"
        [clrAccordionMultiPanel]="true"
        class="tech-support-wizard-page__accordion"
    >
        <clr-accordion-panel
            #clrPanel
            [clrAccordionPanelOpen]="item.key !== 'success' && item.value.length > 0"
            *ngFor="let item of groupedPrechecks | keyvalue: unsorted; trackBy: trackByIndex"
        >
            <clr-accordion-title>{{ checkStatusGroupHash[item.key] | vtranslate : item.value.length }}</clr-accordion-title>

            <clr-accordion-content>
                <ul>
                    <li
                        *ngFor="let check of item.value; trackBy: trackByIndex"
                        class="tech-support-wizard-page__item"
                    >
                        <div class="tech-support-wizard-page__item-wrapper">
                            <avi-tooltip-icon-with-content-wrapper
                                *ngIf="check.state === preCheckFsmState.SUCCESS"
                                status="success"
                                shape="check-circle"
                                size="20"
                            >
                                {{ l10nKeys.preCheckPassSuccessLabel | vtranslate }}
                            </avi-tooltip-icon-with-content-wrapper>
                
                            <avi-tooltip-icon-with-content-wrapper
                                *ngIf="check.state === preCheckFsmState.ERROR"
                                status="danger"
                                shape="exclamation-circle"
                                size="20"
                            >
                                {{ l10nKeys.preCheckErrorLabel | vtranslate : (check.details ? check.details.join(): '') }}
                            </avi-tooltip-icon-with-content-wrapper>
                
                            <avi-tooltip-icon-with-content-wrapper
                                *ngIf="check.state === preCheckFsmState.WARNING"
                                status="warning"
                                shape="exclamation-circle"
                                size="20"
                            >
                                {{ l10nKeys.preCheckPassWarningLabel | vtranslate }}
                            </avi-tooltip-icon-with-content-wrapper>
                
                            <avi-tooltip-icon-with-content-wrapper
                                *ngIf="check.state === preCheckFsmState.STARTED"
                                status="info"
                                shape="circle"
                                size="20"
                            >
                                {{ l10nKeys.preCheckPendingLabel | vtranslate }}
                            </avi-tooltip-icon-with-content-wrapper>
                
                            <clr-spinner
                                *ngIf="check.state === preCheckFsmState.IN_PROGRESS"
                                class="tech-support-wizard-page__spinner"
                                clrInline
                            ></clr-spinner>
                
                            <span class="tech-support-wizard-page__label">{{ check.description | trimSingleQuote }}</span>
                        </div>
                        <clr-accordion class="tech-support-wizard-page__inner-accordion">
                            <clr-accordion-panel #clrInnerPanel>
                                <clr-accordion-title class="tech-support-wizard-page__inner-accordion-label">
                                    {{ l10nKeys.viewDetailsLabel | vtranslate }}
                                    ({{ check?.details?.length ?? 0 }})
                                </clr-accordion-title>
                                <clr-accordion-content>
                                    <div
                                        class="tech-support-wizard-page__inner-accordion-content"
                                        *ngFor="let detail of check.details; trackBy: trackByIndex"
                                    >
                                        {{ detail }}
                                    </div>
                                </clr-accordion-content>
                            </clr-accordion-panel>
                        </clr-accordion>
                    </li>
                </ul>
            </clr-accordion-content>
        </clr-accordion-panel>
    </clr-accordion>
    <clr-accordion 
        *ngIf="page === 'packaging'"
        [clrAccordionMultiPanel]="true"
        class="tech-support-wizard-page__accordion"
    >
        <clr-accordion-panel
            #clrPanel
            [clrAccordionPanelOpen]="item.key !== 'success' && item.value.length > 0"
            *ngFor="let item of groupedTasks | keyvalue: unsorted; trackBy: trackByIndex"
        >
            <clr-accordion-title>{{ checkStatusGroupHash[item.key] | vtranslate : item.value.length }}</clr-accordion-title>

            <clr-accordion-content>
                <ul>
                    <li
                        *ngFor="let check of item.value; trackBy: trackByIndex"
                        class="tech-support-wizard-page__item"
                    >
                        <div class="tech-support-wizard-page__item-wrapper">
                            <avi-tooltip-icon-with-content-wrapper
                                *ngIf="check.status === taskFsmStatus.SUCCESS"
                                status="success"
                                shape="check-circle"
                                size="20"
                            >
                                {{ l10nKeys.preCheckPassSuccessLabel | vtranslate }}
                            </avi-tooltip-icon-with-content-wrapper>
                
                            <avi-tooltip-icon-with-content-wrapper
                                *ngIf="check.status !== taskFsmStatus.SUCCESS"
                                status="warning"
                                shape="exclamation-circle"
                                size="20"
                            >
                                {{ l10nKeys.preCheckPassWarningLabel | vtranslate }}
                            </avi-tooltip-icon-with-content-wrapper>
                            <span class="tech-support-wizard-page__label">{{ check.description | trimSingleQuote }}</span>
                        </div>
                        <clr-accordion class="tech-support-wizard-page__inner-accordion">
                            <clr-accordion-panel #clrInnerPanel>
                                <clr-accordion-title class="tech-support-wizard-page__inner-accordion-label">
                                    {{ l10nKeys.viewDetailsLabel | vtranslate }}
                                    ({{ check?.details?.length ?? 0 }})
                                </clr-accordion-title>
                                <clr-accordion-content>
                                    <div
                                        class="tech-support-wizard-page__inner-accordion-content"
                                        *ngFor="let detail of check.details; trackBy: trackByIndex"
                                    >
                                        {{ detail }}
                                    </div>
                                </clr-accordion-content>
                            </clr-accordion-panel>
                        </clr-accordion>
                    </li>
                </ul>
            </clr-accordion-content>
        </clr-accordion-panel>
    </clr-accordion>
    <div>
        <h6>{{ l10nKeys.transcriptLabel | vtranslate }}</h6>
        <avi-textarea-container>
            <textarea
                clrTextarea
                [ngModel]="transcript"
                name="package-transcript"
                class="tech-support-wizard-page__transcript-textarea"
                readonly
            ></textarea>
        </avi-textarea-container>
    </div> 
</div>
